import { ChangeEvent } from 'react';
import { mapValues, pickBy } from 'lodash';
import { DeviceClass, DeviceTypeId, DeviceType } from 'shared/models';
import { ListSelectField, TextField } from 'ui/shared/controls';
import { FormData } from "../AddDevicesForm";

require('./AddModemFormFields.css');

export type Props = {
    deviceTypes: Record<DeviceTypeId, DeviceType>;
    data: FormData;
    onChange(e: ChangeEvent<HTMLInputElement | HTMLSelectElement>): void;
};

const nullValue = '';

export const AddModemFormFields = ({ deviceTypes, data, onChange }: Props) => {
    const modemDeviceTypes = mapValues(pickBy(deviceTypes, dt => dt.deviceClass === DeviceClass.Modem), dt => dt.displayName);
    
    const currentValue =
        Object.keys(modemDeviceTypes).includes(data.deviceTypeId!)
            ? data.deviceTypeId!
            : nullValue;

    return (
        <div id="add-modem-form-fields" className="add-devices-form-fields">
            <ListSelectField
                id="add-modem-form_type"
                className="device-type-id-field"
                name="deviceTypeId"
                size={ 6 }
                labelKey="DEVICES.EDIT_DIALOG.FIELD.DEVICE_TYPE"
                value={ currentValue }
                options={ modemDeviceTypes }
                required={ true }
                showNone={ false }
                onChange={ onChange }
            />
            <TextField
                id="add-modem-form_serial-number"
                className="serial-number-field"
                name="properties.serialNumber"
                labelKey="DEVICES.EDIT_DIALOG.FIELD.SERIAL_NUMBER"
                maxLength={ 32 }
                autoComplete="off"
                required={ true }
                value={ data.properties?.serialNumber || '' }
                onChange={ onChange }
            />
        </div>
    );
};
